/**
 * Injects environment variables into the client via window.__BLOOM_CLIENT_ENV__.
 *
 * SECURITY NOTE: Values passed here ARE visible to end users in browser devtools.
 * Only pass non-sensitive, public configuration (e.g., Mixpanel project tokens,
 * public API keys). NEVER pass secrets, private API keys, or sensitive data.
 * These values were already client-visible via loader data - this just makes
 * them available earlier for SDK initialization.
 *
 * IMPORTANT: Only use this component once in the document.
 * Downstream code should NOT read from window.__BLOOM_CLIENT_ENV__ directly.
 * This is only for early SDK initialization in entry.client.tsx.
 * Components should get data from loaders/context instead.
 *
 * XSS Safety: JSON.stringify escapes special characters (<, >, etc.) and values
 * originate from trusted server-side loader data, not user input.
 */
export const ClientEnv = ({ values }: { values: Record<string, unknown> }) => (
  <script
    dangerouslySetInnerHTML={{
      __html: `window.__BLOOM_CLIENT_ENV__=${JSON.stringify(values)}`,
    }}
  />
);
